import React from 'react';
import { Routes, Route } from 'react-router-dom';

import Authenticated from 'src/components/Authenticated/Authenticated';
import SegmentAnalytics from 'src/components/SegmentAnalytics/SegmentAnalytics';
import Urls from 'src/config/routes';
import BoostedAd from 'src/views/BoostedAd/BoostedAd';
import Dashboard from 'src/views/Dashboard/Dashboard';
import Enquiries from 'src/views/Enquiries/Enquiries';
import Franchise from 'src/views/Franchise/Franchise';
import { FreeListingContractPage } from 'src/views/FreeListingContract/FreeListingContractPage';
import MarketplaceInsights from 'src/views/MarketplaceInsights/MarketplaceInsights';
import NotFound from 'src/views/NotFound/NotFound';
import Onboarding from 'src/views/Onboarding/Onboarding';
import PackagesPage from 'src/views/PackagesPage/PackagesPage';
import { PayPerEnquiryContract } from 'src/views/PayPerEnquiryContract/PayPerEnquiryContract';
import { PaymentPage } from 'src/views/Payment/PaymentPage';
import { PaymentSuccessPage } from 'src/views/PaymentSuccess/PaymentSuccessPage';
import PostListing from 'src/views/PostListing/PostListing';
import Preferences from 'src/views/Preferences/Preferences';
import PreferencesSubmitted from 'src/views/PreferencesSubmitted/PreferencesSubmitted';
import { PriceGuide } from 'src/views/PriceGuide/PriceGuide';
import { PriceGuideEstimation } from 'src/views/PriceGuide/PriceGuideEstimation';
import { PriceGuideOperations } from 'src/views/PriceGuide/PriceGuideOperations';
import PrivateSellerSEM from 'src/views/PrivateSellerSEM/PrivateSellerSEM';
import PrivateSellerSEMv2 from 'src/views/PrivateSellerSEMv2/PrivateSellerSEM';
import Profile from 'src/views/Profile/Profile';
import RecommendationUnsubscribe from 'src/views/RecommendationUnsubscribe/RecommendationUnsubscribe';
import RenewListing from 'src/views/RenewListing/RenewListing';
import RenewListingSuccess from 'src/views/RenewListingSuccess/RenewListingSuccess';
import Unsubscribe from 'src/views/Unsubscribe/Unsubscribe';
import { UpgradeContractRequestConfirmation } from 'src/views/UpgradeContractRequest/UpgradeContractRequestConfirmation';

const Router = () => (
  <Routes>
    <Route
      path={Urls.BOOSTED_AD}
      element={
        <Authenticated mode="legacy-authenticated">
          <SegmentAnalytics pageTitle="sell_boosted_ad">
            <BoostedAd />
          </SegmentAnalytics>
        </Authenticated>
      }
    />
    <Route
      path={Urls.RENEW_LISTING}
      element={
        <Authenticated mode="legacy-auth0-authenticated">
          <SegmentAnalytics pageTitle="sell_renew_listing">
            <RenewListing />
          </SegmentAnalytics>
        </Authenticated>
      }
    />
    <Route
      path={Urls.RENEW_LISTING_SUCCESS}
      element={
        <SegmentAnalytics pageTitle="sell_renew_listing_success">
          <RenewListingSuccess />
        </SegmentAnalytics>
      }
    />
    <Route
      path={Urls.FRANCHISE_HUB}
      element={
        <SegmentAnalytics pageTitle="franchises_licensing_distribution">
          <Franchise />
        </SegmentAnalytics>
      }
    />
    <Route
      path={Urls.RECOMMENDATION_UNSUBSCRIBE}
      element={
        <SegmentAnalytics pageTitle="buyer_recommendation_unsubscribe">
          <RecommendationUnsubscribe />
        </SegmentAnalytics>
      }
    />
    <Route
      path={Urls.PREFERENCES_SUBMITTED}
      element={
        <SegmentAnalytics pageTitle="buyer_preferences_submitted">
          <PreferencesSubmitted />
        </SegmentAnalytics>
      }
    />
    <Route
      path={Urls.BUYER_PREFERENCES}
      element={
        <Authenticated mode="simple">
          <SegmentAnalytics pageTitle="buyer_preferences">
            <Preferences />
          </SegmentAnalytics>
        </Authenticated>
      }
    />
    <Route
      path={Urls.DASHBOARD}
      element={
        <Authenticated mode="legacy-authenticated">
          <SegmentAnalytics pageTitle="sell_dashboard">
            <Dashboard />
          </SegmentAnalytics>
        </Authenticated>
      }
    />
    <Route
      path={Urls.PAYMENT}
      element={
        <Authenticated mode="legacy-authenticated">
          <SegmentAnalytics pageTitle="sell_payment">
            <PaymentPage />
          </SegmentAnalytics>
        </Authenticated>
      }
    />
    <Route
      path={Urls.PAYMENT_SUCCESS}
      element={
        <Authenticated mode="legacy-authenticated">
          <SegmentAnalytics pageTitle="sell_payment_success">
            <PaymentSuccessPage />
          </SegmentAnalytics>
        </Authenticated>
      }
    />
    <Route
      path={Urls.PACKAGES}
      element={
        <Authenticated mode="legacy-authenticated">
          <SegmentAnalytics pageTitle="sell_packages">
            <PackagesPage />
          </SegmentAnalytics>
        </Authenticated>
      }
    />
    <Route
      path={Urls.PAY_PER_ENQUIRY_CONTRACT}
      element={
        <Authenticated mode="legacy-authenticated">
          <SegmentAnalytics pageTitle="sell_pay_per_enquiry_contract">
            <PayPerEnquiryContract />
          </SegmentAnalytics>
        </Authenticated>
      }
    />
    <Route
      path={Urls.FREEMIUM_CONTRACT}
      element={
        <Authenticated mode="legacy-authenticated">
          <SegmentAnalytics pageTitle="sell_free_listing_contract">
            <FreeListingContractPage />
          </SegmentAnalytics>
        </Authenticated>
      }
    />
    <Route
      path={Urls.ONBOARDING}
      element={
        <Authenticated mode="legacy-auth0-authenticated">
          <SegmentAnalytics pageTitle="onboarding">
            <Onboarding />
          </SegmentAnalytics>
        </Authenticated>
      }
    />
    <Route
      path={Urls.POST_LISTING}
      element={
        <Authenticated mode="legacy-authenticated">
          <SegmentAnalytics pageTitle="sell_listing_repost">
            <PostListing />
          </SegmentAnalytics>
        </Authenticated>
      }
    />
    <Route
      path={Urls.PRICE_GUIDE}
      element={
        <Authenticated mode="legacy-authenticated">
          <SegmentAnalytics pageTitle="price_guide">
            <PriceGuide />
          </SegmentAnalytics>
        </Authenticated>
      }
    />
    <Route
      path={Urls.PRICE_GUIDE_ESTIMATION}
      element={
        <Authenticated mode="legacy-authenticated">
          <SegmentAnalytics pageTitle="price_guide">
            <PriceGuideEstimation />
          </SegmentAnalytics>
        </Authenticated>
      }
    />
    <Route
      path={Urls.PRICE_GUIDE_OPERATIONS}
      element={
        <Authenticated mode="legacy-authenticated">
          <SegmentAnalytics pageTitle="price_guide">
            <PriceGuideOperations />
          </SegmentAnalytics>
        </Authenticated>
      }
    />
    <Route
      path={Urls.LISTING_ENQUIRIES}
      element={
        <Authenticated mode="legacy-auth0-authenticated">
          <SegmentAnalytics pageTitle="sell_listings_enquiries">
            <Enquiries />
          </SegmentAnalytics>
        </Authenticated>
      }
    />
    <Route
      path={Urls.PROFILE_DETAILS}
      element={
        <Authenticated mode="legacy-auth0-authenticated">
          <SegmentAnalytics pageTitle="my_profile">
            <Profile />
          </SegmentAnalytics>
        </Authenticated>
      }
    />
    <Route
      path={Urls.PROFILE_SAVED_BUSINESSES}
      element={
        <Authenticated mode="legacy-auth0-authenticated">
          <SegmentAnalytics pageTitle="my_profile">
            <Profile />
          </SegmentAnalytics>
        </Authenticated>
      }
    />
    <Route
      path={Urls.PROFILE_SAVED_SEARCHES}
      element={
        <Authenticated mode="legacy-auth0-authenticated">
          <SegmentAnalytics pageTitle="my_profile">
            <Profile />
          </SegmentAnalytics>
        </Authenticated>
      }
    />
    <Route
      path={Urls.PRIVATE_SELLER_SEM}
      element={
        <SegmentAnalytics pageTitle="sell_your_business_sem_v1">
          <PrivateSellerSEM />
        </SegmentAnalytics>
      }
    />
    <Route
      path={Urls.PRIVATE_SELLER_SEM_V2}
      element={
        <SegmentAnalytics pageTitle="sell_your_business_sem_v2">
          <PrivateSellerSEMv2 />
        </SegmentAnalytics>
      }
    />
    <Route
      path={Urls.UNSUBSCRIBE}
      element={
        <SegmentAnalytics pageTitle="unsubscribe">
          <Unsubscribe />
        </SegmentAnalytics>
      }
    />
    <Route
      path={Urls.MARKETPLACE_INSIGHTS}
      element={
        <SegmentAnalytics pageTitle="marketplace_insights">
          <MarketplaceInsights />
        </SegmentAnalytics>
      }
    />
    <Route
      path={Urls.UPGRADE_CONTRACT_REQUEST_CONFIRMATION}
      element={
        <Authenticated mode="legacy-authenticated">
          <SegmentAnalytics pageTitle="sell_upgrade_contract_request">
            <UpgradeContractRequestConfirmation />
          </SegmentAnalytics>
        </Authenticated>
      }
    />
    <Route path={Urls.PAGE_NOT_FOUND} element={<NotFound />} />
    <Route path="*" element={<NotFound />} />
  </Routes>
);

export default Router;
